import React, { useState } from 'react';
import { motion } from 'framer-motion';
import LessonPreview from '../lesson/LessonPreview';
import LessonFour from '../lesson/LessonFour';
import InteractiveModal from '../lesson/InteractiveModal';

const SlideLessonView: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <div className="flex items-center justify-center h-full px-16">
        <div className="flex items-center gap-16 max-w-6xl">
          {/* Left: Text content */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="flex-1"
          >
            <h2 className="text-5xl font-bold text-white mb-6">
              Interactive Lessons
            </h2>
            <p className="text-2xl text-[#94a3b8] mb-8 leading-relaxed">
              Curriculum-aligned question artefacts designed to assess and build mastery.
            </p>

            <div className="space-y-5">
              {[
                { icon: '📚', text: 'Questions mapped to curriculum outcomes' },
                { icon: '🎯', text: 'Difficulty calibrated to each concept' },
                { icon: '💡', text: 'Hints and explanations support learning' },
                { icon: '⭐', text: 'Instant feedback with XP rewards' },
              ].map((item, i) => (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.3 + i * 0.1 }}
                  className="flex items-center gap-4"
                >
                  <span className="text-3xl">{item.icon}</span>
                  <span className="text-xl text-[#e2e8f0]">{item.text}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Right: Lesson Preview */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="flex-shrink-0"
            style={{ transform: 'scale(1.8)', transformOrigin: 'center' }}
          >
            <LessonPreview onClick={() => setIsModalOpen(true)} />
          </motion.div>
        </div>
      </div>

      {/* Interactive Lesson Modal */}
      <InteractiveModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <LessonFour onClose={() => setIsModalOpen(false)} />
      </InteractiveModal>
    </>
  );
};

export default SlideLessonView;
